import { useState } from 'react';
import { SplitValue } from 'modules/workflows';
import { getHasDefaultSplit } from './utils';

export const customSplitValue: SplitValue = { value: '', isDefault: false };
export const defaultSplitValue: SplitValue = { value: '', isDefault: true };

export const DEFAULT_SPLITS: SplitValue[] = [customSplitValue, customSplitValue, defaultSplitValue]; // We want default split to be on by default

const getInitialState = (initialSplitValues: SplitValue[]) =>
  initialSplitValues.length >= 2 ? initialSplitValues : DEFAULT_SPLITS;

const insert = (arr: SplitValue[], index: number, newItem: SplitValue) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index),
];

export const useSplitValues = (initialSplitValues: SplitValue[] = []) => {
  const [splitValues, setSplitValues] = useState<SplitValue[]>(getInitialState(initialSplitValues));
  const [hasDefaultSplit, setHasDefaultSplit] = useState<boolean>(getHasDefaultSplit(splitValues));

  const onAdd = () => {
    const indexOfDefault = splitValues.findIndex((x) => x.isDefault);
    setSplitValues((state) => {
      const newState =
        indexOfDefault > -1
          ? insert(state, indexOfDefault, customSplitValue)
          : [...state, customSplitValue];
      return newState;
    });
  };

  const onClearAll = () =>
    setSplitValues((state) => state.map((split) => ({ ...split, value: '' })));

  const onRemove = (index: number) =>
    setSplitValues((state) => [...state.filter((_, i) => i !== index)]);

  const onUpdate = (value: string, index: number) =>
    setSplitValues((state) => {
      const arr: SplitValue[] = [...state];
      const item = arr[index];
      arr[index] = { ...item, value };
      arr[index] = { ...item, value: value || '' };
      return arr;
    });

  const onDefaultSplit = (shouldAddDefaultSplit: boolean) => {
    setSplitValues((state) => [
      ...state.filter(({ isDefault }) => !isDefault),
      ...(shouldAddDefaultSplit ? [defaultSplitValue] : []),
    ]);
    setHasDefaultSplit(shouldAddDefaultSplit);
  };

  return {
    splitValues,
    hasDefaultSplit,
    onAdd,
    onClearAll,
    onRemove,
    onUpdate,
    onDefaultSplit,
  };
};
